var map = {
	"./add.png": "LklT",
	"./banner.png": "XD8J",
	"./bgc.png": "HHxx",
	"./checkbox.png": "5ZEc",
	"./checked.png": "Q9at",
	"./error.png": "P+BA",
	"./faild.png": "Uy/e",
	"./flow10.png": "ynLz",
	"./flow11.png": "JNwv",
	"./flow12.png": "D4Lk",
	"./flow13.png": "wA25",
	"./flow20.png": "Xk5d",
	"./flow21.png": "biYA",
	"./flow22.png": "logq",
	"./flow23.png": "zJg4",
	"./loading.png": "iA8E",
	"./logo.png": "p/nH",
	"./qm_icon.png": "iOZH",
	"./qm_icon_no.png": "xXgD",
	"./seal_icon.png": "jTqr",
	"./success.png": "PpCj",
	"./sx_icon.png": "L0PT",
	"./time_stamp_icon.png": "tOQW",
	"./time_stamp_icon_no.png": "9MZ6",
	"./upload.png": "cPGQ",
	"./upload_icon.png": "qC/F",
	"./verify.png": "MNwx",
	"./wz_icon.png": "ElJ3",
	"./wz_noopen_icon.png": "qm4N",
	"./xml.png": "xy7U",
	"./会计凭证.png": "fbmq",
	"./电子发票.png": "UH3q",
	"./电子回单.png": "Q/fe",
	"./电子客票（高铁）.png": "tP/r",
	"./电子对账单.png": "gFoT",
	"./航空行程单.png": "W37d",
	"./非税票据.png": "ls6O"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Sonc";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic ^\.\/.*\.png$
// module id = Sonc
// module chunks = 2